// extracted by mini-css-extract-plugin
export default {"carousel":"uH-z"};